import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import FieldTip from '../ui/FieldTip';

const StockFields = ({ formData, onFieldChange, config, setConfig }) => {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="ticker_symbol" className="portfolio-input-label">Ticker Symbol<FieldTip field="ticker_symbol" /></Label>
        <Input
          id="ticker_symbol"
          data-testid="ticker-symbol-input"
          placeholder="e.g. AAPL, GOOGL"
          value={formData.ticker_symbol}
          onChange={(e) => onFieldChange('ticker_symbol', e.target.value)}
          className="portfolio-input"
        />
      </div>
    </>
  );
};

export default StockFields;
